var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.3574V4.20742L4.9 6.80742L3.5 5.35742L8.5 0.357422L13.5 5.35742L12.1 6.80742L9.5 4.20742V12.3574H7.5ZM2.5 16.3574C1.95 16.3574 1.47933 16.1618 1.088 15.7704C0.696666 15.3791 0.500667 14.9081 0.5 14.3574V11.3574H2.5V14.3574H14.5V11.3574H16.5V14.3574C16.5 14.9074 16.3043 15.3784 15.913 15.7704C15.5217 16.1624 15.0507 16.3581 14.5 16.3574H2.5Z",
    fill: "#10A37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.9a21a1a829e618ba2c2aceae8274c002.svg";
export { ForwardRef as ReactComponent };